import '@angular/localize/init';
export * from './lib/feature-tax-wage-details.module';

export * from './lib/tax-wage-details/feature-tax-wage-details.component';
